<assignment-selector
  [config]="config"
  [selected]="selected"
  (selectedChange)="update($event)"
></assignment-selector>
